import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Optional,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

/**
 * Shows the host's matTooltip only while its text is actually clipped by
 * `text-overflow: ellipsis`, so a tooltip never just repeats what is already
 * fully visible.
 *
 * Pair it with matTooltip on the same element - bind the message there so it is
 * always correct, and let this directive decide whether the tooltip is offered:
 *
 *   <td class="ellipsised" [matTooltip]="row.product" appTruncatedTooltip>
 *     {{ row.product }}
 *   </td>
 *
 * The check is re-run on hover rather than on every change detection pass,
 * because reading scrollWidth forces a layout.
 */
@Directive({
  selector: '[appTruncatedTooltip]',
})
export class TruncatedTooltipDirective implements AfterViewInit {
  constructor(
    private elementRef: ElementRef<HTMLElement>,
    @Optional() private tooltip: MatTooltip
  ) {}

  ngAfterViewInit(): void {
    this.syncTooltipState();
  }

  @HostListener('mouseenter')
  public onMouseEnter(): void {
    this.syncTooltipState();
  }

  private syncTooltipState(): void {
    if (!this.tooltip) return;
    const node = this.elementRef.nativeElement;
    this.tooltip.disabled = node.scrollWidth <= node.clientWidth;
  }
}
